module.exports = __webpack_public_path__ + "img/harga-special.78d3643b.svg";